

























































































import BaseComponent from '@/components/base-component.vue';
import PrescriptionTypesBlank from '@/components/prescription/types/blank.vue';
import PrescriptionTypesCopy from '@/components/prescription/types/copy.vue';
import PrescriptionTypesModel from '@/components/prescription/types/model.vue';
import PrescriptionTypesPattern from '@/components/prescription/types/pattern.vue';
import LockChildren from '@/components/UI/lock-children.vue';
import { IdNomeDTO } from '@/interfaces/base-dto';
import { PrescricaoParmDTO } from '@/interfaces/prescription';
import { MedidasProdutosEnteralResult } from '@/interfaces/product';
import DoctorModel from '@/models/doctor-model';
import PrescriptionModel from '@/models/prescription-model';
import { getPrescriptionTypes } from '@/services/prescription';
import * as prescriptionsTypes from '@/settings/consts/prescriptions-types';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';



@Component({
  components: {
    PrescriptionTypesBlank,
    PrescriptionTypesModel,
    PrescriptionTypesPattern,
    PrescriptionTypesCopy,
    LockChildren,
  },
})
export default class PrescriptionTypesTabs extends BaseComponent {
  @Prop()
  public item: PrescriptionModel;
  @Prop()
  public imc: any;
  @Prop()
  public copyItem: PrescriptionModel;
  @Prop()
  public visualization?: boolean;
  @Prop()
  public lockTabs?: boolean;
  @Prop()
  public transcriptionType?: boolean;
  @Prop()
  public enteralResult: MedidasProdutosEnteralResult;
  @Prop()
  public draft: PrescricaoParmDTO;

  public tabsLocked: boolean = false;
  public activeTab: string = 'tab-prescription-blank';

  public alertTitleType: string = 'Alterar Tipo de Prescrição?';
  public alertMessageType: string =
    'Ao alterar, as informações de Dados Complementares e Produtos serão perdidas.';
  public alertTitleModel: string = 'Alterar Modelo de Prescrição?';
  public alertTitlePattern: string = 'Alterar Padrão de Prescrição?';
  public alertTitleProfile: string = 'Alterar Perfil de Prescrição?';
  public alertTitleCopy: string = 'Alterar Referência de Prescrição?';

  public itemCopia: PrescriptionModel;
  public prescritionTypeMessage: string;

  private prescTypes: IdNomeDTO[] = [];

  private mapTypeTabName: Map<String,String> = new Map();
  
  mounted() {
   this.mapTypeTabName[prescriptionsTypes.MODEL] = 'model';
   this.mapTypeTabName[prescriptionsTypes.COPY] = 'copy';
   this.mapTypeTabName[prescriptionsTypes.PATTERN] = 'pattern';
   this.mapTypeTabName[prescriptionsTypes.DEFAULT] = 'blank';
  }
  
  @Watch('item')
  public loadPrescritionType(val: PrescriptionModel) {
    this.prescritionTypeMessage = val.descricaoTipo;
    if (this.visualization) {
      return;
    }
    switch(val.tipoPrescricao) {
      case prescriptionsTypes.MODEL: { 
        this.activeTab = 'tab-prescription-model';
        break; 
      }
      
      case prescriptionsTypes.COPY: {              
        this.activeTab = 'tab-prescription-copy';
        break; 
      } 
     
      case prescriptionsTypes.PATTERN: {              
        this.activeTab = 'tab-prescription-pattern';          
        break; 
      }             
      
      default: {              
        this.activeTab = 'tab-prescription-blank';          
        break; 
      }             
    } 
  } 

  @Watch('copyItem')
  public onCopyItemChange(copyItem: PrescriptionModel) {
    if (!copyItem || !copyItem.idPrescricao) {
      return;
    }
    this.sleepUntil(() => {
      return !this.isTabsDisabled() && this.prescTypes && this.prescTypes.length;
    }, 180000).then(() => {
      this.manualChangeTab(this.mapTypeTabName[copyItem.tipoPrescricao]);
    });
  }

  @Watch('draft')
  public onDraftChange(draft: PrescricaoParmDTO) {
    if (!draft || !draft.tipoPrescricao) {
      return;
    }
    this.sleepUntil(() => {
      return !this.isTabsDisabled() && this.prescTypes && this.prescTypes.length;
    }, 180000).then(() => {
      this.manualChangeTab(this.mapTypeTabName[draft.tipoPrescricao]);
    });
  }
  

  public checkTabSelection(checker: any): boolean {
    return 'tab-prescription-' + checker == this.activeTab;
  }

  public manualChangeTab(tab: string): any {
    if (this.isTabsDisabled()) {
      return;
    }

    if (!this.item.isLocked()) {
      this.activeTab = 'tab-prescription-' + tab;
      return;
    }

    this.activeTab = 'tab-prescription-' + tab;
    this.$emit('unlockTabs');  
  }

  public isTabsDisabled(): boolean {
    if (
      this.hasntClientSelected(this.item) ||
      this.hasntPatientSelected(this.item)
    ) {
     // this.activeTab = 'tab-prescription-blank';
      return true;
    }
    return false;
  }

  public isTranscription(): boolean{
    return this.transcriptionType;
  }

  public hasntClientSelected(item): boolean {
    return !(!!item.unidade && !!item.unidade.id);
  }

  public hasntPatientSelected(item): boolean {
    return !(!!item.paciente && !!item.paciente.id);
  }

  @Watch('lockTabs')
  public onChangeLockTabs(val: boolean): void {
    this.tabsLocked = val;
  }

  @Watch('item.medico')
  public onChangeMedico(medico: DoctorModel): void {
    this.$emit('typesReady', false);
    if (this.visualization || !medico || !medico.id) {
      this.prescTypes = [];
      return;
    }
    this.addSubsc(getPrescriptionTypes(this.item.unidade.id, Number(medico.id)).subscribe(res => {
      this.prescTypes = res;
      if (res.length) {
        this.manualChangeTab(this.mapTypeTabName[res[0].id]);
        this.$emit('typesReady', true);
      }
    }));
  }

  private isAvailableTab(tabType:string) : boolean {
    return this.prescTypes.filter(f => f.id == tabType).length > 0;
  }

  public onChangeBlank(val): void {
    this.$emit('updateBlank', val);
  }

  public onChangeModel(val): void {
    const payload = {
      divisaoBolsas: val.divisaoBolsas,
      viaAdministracao: val.viaAdministracao,
      volumeDesejado: val.volumeDesejado,      
      volumeDigitadoPorKg: val.volumeDigitadoPorKg,
      volumeDigitado: val.volumeDigitado,
      tempoInfusao: val.tempoInfusao,
      leito: val.leito,
      same: val.same,
      setor: val.setor,
      endereco: val.endereco && val.endereco.ativo ? val.endereco : null,
      enderecoAtivo: val.endereco && val.endereco.ativo,
      convenio: val.convenio,
      produtos: val.produtos,
      paciente: val.paciente,
      idPrescricaoCopia: val.idPrescricao,
      usoPesoCalorico: val.usoPesoCalorico,
      quantidade: val.quantidade,
      bolsaMulticompart: val.bolsaMulticompart
    };

    this.$emit('updateModel', payload);
  }

  public onChangeCopy(val): void {
    const payload = {
      divisaoBolsas: val.divisaoBolsas,
      viaAdministracao: val.viaAdministracao,      
      volumeDesejado: val.volumeDesejado,
      volumeDigitadoPorKg: val.volumeDigitadoPorKg,
      volumeDigitado: val.volumeDigitado,
      tempoInfusao: val.tempoInfusao,
      leito: val.leito,
      same: val.same,
      setor: val.setor,
      endereco: val.endereco && val.endereco.ativo ? val.endereco : null,
      enderecoAtivo: val.endereco && val.endereco.ativo,
      convenio: val.convenio,
      produtos: val.produtos,
      paciente: val.paciente,
      idPrescricaoCopia: val.idPrescricao,
      usoPesoCalorico: val.usoPesoCalorico,
      quantidade: val.quantidade,
      bolsaMulticompart: val.bolsaMulticompart
    };

    this.$emit('updateCopy', payload);
  }

  public onChangeProfile(val): void {
    const payload = {
      idTemplate: val.id,
      volumeDesejado: val.volumeDesejado,
      tempoInfusao: val.tempoInfusao,
      produtos: val.produtos,
    };

    this.$emit('updateProfile', payload);
  }

  public onChangePattern(val): void {
    const payload = {
      idTemplate: val.id,
      volumeDesejado: val.volumeDesejado,
      tempoInfusao: this.item.tempoInfusao,
      produtos: val.produtos,
    };

    this.$emit('updatePattern', payload);
  }
}
